package com.mgacreative.hotel.feature.restaurant.di

import com.mgacreative.hotel.feature.restaurant.ui.PosViewModel
import com.mgacreative.hotel.feature.restaurant.ui.RestaurantViewModel
import org.koin.core.module.dsl.viewModel
import org.koin.dsl.module

fun getRestaurantFeatureModule() = module {
    viewModel { RestaurantViewModel(get(), get()) }
    viewModel { PosViewModel(get(), get(), getOrNull()) }
}
